import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import CreateView from "../../common/create";
import EnforcementTabletCreateViewModel from "viewModels/enforcement/enforcementTablets/enforcementTabletCreateViewModel";
import EnforcementTabletForm from "./enforcementTabletForm";

const EnforcementTabletCreateView: ViewComponent<EnforcementTabletCreateViewModel> = observer(({ vm }) => {
  return <CreateView vm={vm} form={<EnforcementTabletForm vm={vm} />} />;
});

registerView(EnforcementTabletCreateView, EnforcementTabletCreateViewModel);
